import React, { useContext, useState } from "react";
import TenderingLandingPageContext from "../../../contexts/TenderingLandingPageContext";
import ComboBox from "../../../components/common/ComboBox";
import { Form, Formik } from "formik";
import AppContext from "../../../AppContext";
import { Button, DatePicker, TextBox } from "../../../components";
import designBanner from "../../../assets/tendering/landing/landing-design-optimised.webp";
import designConstruction from "../../../assets/tendering/landing/landing-construction-optimised.webp";
import { provinces } from "../../../helpers/common.helper";
import { startOfDay } from "date-fns";

const Header = (props) => {
  const [tab, setTab] = useState(1);
  const { filter, setFilter } = useContext(TenderingLandingPageContext);
  const { designStyles } = useContext(AppContext);

  const _getTabClassname = (value) => {
    if (tab === value)
      return "tendering__landing__header__content__tabs__tab tendering__landing__header__content__tabs__tab--active";

    return "tendering__landing__header__content__tabs__tab";
  };

  const handleSubmit = (values, { setSubmitting }) => {
    let _filter = { category: tab };

    for (const key in values) {
      if (!Object.prototype.hasOwnProperty.call(values, key)) continue;

      const element = values[key];

      if (element === undefined) continue;

      _filter[key] = element;
    }

    setFilter(_filter);
    setSubmitting(false);
  };

  return (
    <div className="tendering__landing__header">
      <img
        className="tendering__landing__header__background"
        src={tab === 1 ? designBanner : designConstruction}
      />
      <div className="tendering__landing__header__blur" />
      <div className="tendering__landing__header__content">
        <h3 className="tendering__landing__header__content__title">
          Tendering
        </h3>
        <div className="tendering__landing__header__content__tabs">
          <div className={_getTabClassname(1)} onClick={() => setTab(1)}>
            Design
          </div>
          <div className={_getTabClassname(2)} onClick={() => setTab(2)}>
            Construction
          </div>
        </div>
        <Formik
          initialValues={{
            work: undefined,
            budget: undefined,
            area: undefined,
            location: undefined,
            date: startOfDay(new Date()),
          }}
          onSubmit={handleSubmit}
        >
          <Form className="tendering__landing__header__content__form">
            <ComboBox
              name="work"
              options={designStyles.works}
              label="Type of Work"
              style={{ gridArea: "work" }}
            />
            <TextBox
              name="budget"
              label="Maximum Budget"
              style={{ gridArea: "budget" }}
              type="number"
            />
            <TextBox
              name="area"
              label="Area Size"
              style={{ gridArea: "size" }}
              type="number"
            />
            <DatePicker
              name="date"
              label={"Tender Start Date"}
              dateFormat="dd/MM/yyyy"
              placeholder={"Start Date"}
            />
            <ComboBox
              name="location"
              options={provinces}
              label="Location"
              style={{ gridArea: "location" }}
            />
            <Button
              style={{
                gridArea: "search",
                justifySelf: "center",
                marginTop: 12,
              }}
              label="Search"
              width={200}
              type="submit"
            />
          </Form>
        </Formik>
      </div>
    </div>
  );
};

Header.propTypes = {};

export default Header;
